import {
  baseUniDriverFactory,
  findByHook,
  isElementFocused,
  ReactBase,
} from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/unidriver-core';
// @ts-ignore
import { textUniDriverFactory } from '../Text/Text.uni.driver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './constants';

export const addItemUniDriverFactory = (base: UniDriver, body: UniDriver) => {
  const tooltipDriver = tooltipDriverFactory(
    findByHook(base, dataHooks.itemTooltip),
    body,
  );
  const textDriver = textUniDriverFactory(findByHook(base, dataHooks.itemText));
  const subtitleTextDriver = textUniDriverFactory(
    findByHook(base, dataHooks.itemSubtitle),
  );

  const addItemElement = findByHook(base, dataHooks.addItem);
  const reactBaseElement = ReactBase(addItemElement);

  return {
    ...baseUniDriverFactory(addItemElement),

    /**
     * Gets AddItem text
     * @return {Promise<string>}
     */
    getText: async (): Promise<string> => textDriver.getText(),

    /**
     * Checks whether AddItem text exist
     * @returns {Promise<boolean>}
     */
    textExists: async (): Promise<boolean> => textDriver.exists(),

    /**
     * Gets tooltip text
     * @return {Promise<string | null>}
     */
    getTooltipContent: async (): Promise<string | null> =>
      tooltipDriver.getTooltipText(),

    /**
     * Gets AddItem subtitle
     * @return {Promise<string>}
     */
    getSubtitle: async (): Promise<string> => subtitleTextDriver.getText(),

    /**
     * Checks whether AddItem is focused
     * @returns {Promise<boolean>}
     */
    isFocused: async (): Promise<boolean> =>
      isElementFocused(addItemElement) as Promise<boolean>,

    /**
     * Sets focus on the element
     * @returns {Promise<void>}
     */
    focus: async (): Promise<void> => reactBaseElement.focus(),

    /**
     * Removes focus on the element
     * @returns {Promise<void>}
     */
    blur: async (): Promise<void> => reactBaseElement.blur(),
  };
};

export type AddItemUniDriver = ReturnType<typeof addItemUniDriverFactory>;
